module.exports = __webpack_public_path__ + "static/media/mn.2dbebe3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mn.svg
// module id = 192
// module chunks = 0